import {BaseEntity} from "./BaseEntity";

export class Employee implements BaseEntity {
    constructor(public id?: number,
                public firstName?: string,
                public lastName?: string,
                public email?: string,
                public phone?: string,
        public rfidTag?: string,
        public vTagID?: string,
        public lastSeen?: string,
        public locationId?: number,
        public locationName?: string,
        public locationSite?: string,
        public locationBuilding?: string,
        public locationFloor?: string,
        public locationRoom?: string
                ) {
    }

    parseJson(json: any): void {
        this.id = json.id;
        this.firstName = json.firstName;
        this.lastName = json.lastName;
        this.email = json.email;
        this.phone = json.phone;
        this.lastSeen = json.lastSeen;
        this.rfidTag = json.rfidTag;
        this.vTagID = json.vTagID;
        this.locationId = json.locationId;
        this.locationName = json.locationName;
        this.locationSite = json.locationSite;
        this.locationBuilding = json.locationBuilding;
        this.locationFloor = json.locationFloor;
        this.locationRoom = json.locationRoom;
    }
}
